import { styled } from '@mui/material/styles';

const FixedFooter = styled('div')({
    position: 'fixed',
    padding: '16px 24px',
    bottom: 0,
    background: 'white',
    left: 'var(--sidebar-width)',
    right: 0,
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    zIndex: 1,
    '@media (max-width: 1024px)': {
        left: 0,
        padding: 16,
    },
});

export default FixedFooter;
